import { QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";

import { queryClient } from "./queryClient";

// The cache every read goes through (ADR 0055), around the app.
export const DataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
